import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://vtqkqntyhgkblizfpafz.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZ0cWtxbnR5aGdrYmxpemZwYWZ6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTgwNjI3OTAsImV4cCI6MjA3MzYzODc5MH0.q-gQcjzptMX4EPHWhDhFLRwi22LozLnQmX5NvxS58gc';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
